export const BUDGET_ID = "budgetId";
export const BUDGET_NAME = "budgetName";
export const VERSION_NO = "versionNo";
export const YEAR = "year";
export const TOTAL_ANNUAL_BUDGET = "totalAnnualBudget";
export const TOTAL_APPROVALS = "totalApprovals";
export const NOTES = "note";
export const LAST_UPDATED_BY = "updatedByName";
export const LAST_UPDATED_ON = "updatedAt";
export const LINE_ITEMS_COUNT = "lineItemsCount";
